import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getApiUrl } from '../config/api';
import './GestionProducto.css';

/**
 * Modal para que el usuario conectado cambie su propia contrasena.
 * Exige la contrasena actual (POST /api/auth/cambiar-clave).
 */
function CambiarClave({ usuario, onCerrar }) {
    const [form, setForm] = useState({ actual: '', nueva: '', repetir: '' });
    const [guardando, setGuardando] = useState(false);
    const [error, setError] = useState('');

    const cambiar = (campo) => (e) => { setForm({ ...form, [campo]: e.target.value }); setError(''); };

    const guardar = async (e) => {
        e.preventDefault();
        if (!form.actual) { setError('Ingrese su contrasena actual'); return; }
        if (form.nueva.length < 6) { setError('La contrasena nueva debe tener al menos 6 caracteres'); return; }
        if (form.nueva !== form.repetir) { setError('Las contrasenas nuevas no coinciden'); return; }
        if (form.nueva === form.actual) { setError('La contrasena nueva debe ser distinta de la actual'); return; }
        setGuardando(true);
        try {
            await axios.post(getApiUrl('/api/auth/cambiar-clave'),
                { usuario, claveActual: form.actual, claveNueva: form.nueva });
            toast.success('Contrasena actualizada');
            onCerrar();
        } catch (err) {
            setError(err.response?.data?.message || 'No se pudo cambiar la contrasena');
        } finally { setGuardando(false); }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-contenido" style={{ maxWidth: '420px' }}>
                <div className="modal-header">
                    <h3>Cambiar mi contrasena</h3>
                    <button onClick={onCerrar} className="btn-cerrar" type="button">&times;</button>
                </div>
                <form onSubmit={guardar} autoComplete="off">
                    <div className="form-group">
                        <label>Contrasena actual *</label>
                        <input type="password" className="form-input" value={form.actual} autoFocus
                               autoComplete="current-password" onChange={cambiar('actual')} />
                    </div>
                    <div className="form-group">
                        <label>Contrasena nueva * (minimo 6 caracteres)</label>
                        <input type="password" className="form-input" value={form.nueva} maxLength={72}
                               autoComplete="new-password" onChange={cambiar('nueva')} />
                    </div>
                    <div className="form-group">
                        <label>Repetir contrasena nueva *</label>
                        <input type="password" className="form-input" value={form.repetir} maxLength={72}
                               autoComplete="new-password" onChange={cambiar('repetir')} />
                    </div>
                    {error && <p className="cambiar-clave-error">{error}</p>}
                    <div className="modal-footer">
                        <button type="button" onClick={onCerrar} className="btn btn-cancelar">Cancelar</button>
                        <button type="submit" className="btn btn-guardar" disabled={guardando}>
                            {guardando ? 'Guardando...' : 'Guardar'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CambiarClave;
